import { SAMPLE_STATES } from '@/constants/samples/states';
import { ValuesOf } from '@/types/utility';

type Sample = { state: ValuesOf<typeof SAMPLE_STATES> };

export const isSampleInProgress = (sample: Sample) => sample.state === SAMPLE_STATES.RUNNING;
